import { render, staticRenderFns } from "./liveInformation.vue?vue&type=template&id=a5bb6ce0&scoped=true"
import script from "./liveInformation.vue?vue&type=script&lang=js"
export * from "./liveInformation.vue?vue&type=script&lang=js"
import style0 from "./liveInformation.vue?vue&type=style&index=0&id=a5bb6ce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bb6ce0",
  null
  
)

export default component.exports